export const SET_INFO = 'SET_INFO';
export const UPDATE_INFO = 'UPDATE_INFO';
export const REMOVE_INFO = 'REMOVE_INFO';
export const UPDATE_ACCESS_AND_REFRESH = 'UPDATE_ACCESS_AND_REFRESH';
export const SET_COMPANY_CODE = 'SET_COMPANY_CODE';
